import { render, staticRenderFns } from "./tab-component.vue?vue&type=template&id=8ade26b8&scoped=true&"
import script from "./tab-component.vue?vue&type=script&lang=js&"
export * from "./tab-component.vue?vue&type=script&lang=js&"
import style0 from "./tab-component.vue?vue&type=style&index=0&id=8ade26b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade26b8",
  null
  
)

export default component.exports